export default __webpack_public_path__ + "static/media/cloud-title.e9d51497.svg";